module.exports = {
	"da": {
		"static-pages": {
			"notFound": {
				"pageTitle": "Siden kunne ikke findes",
				"title": "Applikationen blev ikke fundet",
				"details": "Den applikation, du leder efter, blev ikke fundet. Er du sikker på, du har indtastet adressen korrekt?",
				"goBack": "Gå tilbage"
			},
			"activation": {
				"pageTitle": "Sikkert område",
				"title": "Velkommen til det sikre område",
				"activate": {
					"details": "Et øjeblik; vi forbereder dit aktiveringslink ...",
					"ready": "Dit link er klar. Klik på knappen for at fortsætte. Bemærk: Dette link kan kun bruges én gang.",
					"go": "Aktivér konto"
				},
				"passwordReset": {
					"details": "Et øjeblik; vi forbereder dit link til nulstilling af adgangskode...",
					"ready": "Dit link er klar. Klik på knappen for at fortsætte. Bemærk: Dette link kan kun bruges én gang.",
					"go": "Nulstil adgangskode"
				},
				"error": {
					"details": "Der opstod en fejl med dit link. Prøv igen, eller kontakt support med henvisning til koden."
				}
			},
			"privacy-policy": {
				"pageTitle": "Privatlivspolitik for butiksportal"
			},
			"terms-and-conditions": {
				"pageTitle": "Aftale for butiksportal"
			},
			"Support": {
				"pageTitle": "Support",
				"topic": {
					"orders": "Bestillinger",
					"settlements": "Afregninger",
					"agreements": "Aftaler",
					"technical_issues": "Tekniske problemer",
					"others": "Andre"
				},
				"TicketList": {
					"title": "Supportanmodninger",
					"pageDescription": "Her kan du se status for dine supportanmodninger",
					"status": {
						"open": "Åben",
						"pending": "Afventer",
						"resolved": "Løst",
						"closed": "Lukket",
						"inProgress": "Igangværende",
						"waitingForYourReply": "Venter på dit svar"
					},
					"TicketTable": {
						"id": "Anmodningsnr.",
						"mid": "Butik/MID",
						"subject": "Genstand",
						"status": "Status",
						"updatedAt": "Sidste opdatering"
					}
				},
				"EmptyTicketList": {
					"title": "Du har ikke nogen åbne anmodninger"
				},
				"ticketDetails": {
					"sidebar": {
						"user": {
							"title": "Bruger"
						},
						"details": {
							"title": "Detaljer",
							"store": "Butik/MID",
							"createdAt": "Anmodningsdato",
							"updatedAt": "Sidste opdatering"
						},
						"actions": {
							"close": "Luk anmodningen",
							"reopen": "Genåbn anmodningen"
						},
						"closeTicketDialog": {
							"confirm": "Bekræft",
							"title": "Luk anmodningen",
							"description": "Du er ved at lukke denne anmodning. Du vil kun kunne genåbne den inden for de næste 7 dage.",
							"error": "Hov! Noget gik galt. Prøv igen."
						},
						"reopenTicketDialog": {
							"title": "Genåbn anmodningen",
							"description": "Fortæl os, hvorfor du har brug for at genåbne denne anmodning, og vi vil snarligst vende tilbage til dig.",
							"messageLabel": "Meddelelse"
						}
					},
					"conversation": {
						"loadMore": "Indlæs mere",
						"title": "Anmodning",
						"attachments": {
							"label": "Vedhæftninger"
						},
						"reply": {
							"title": "Tilføj svar",
							"body": {
								"label": "Tilføj et svar",
								"error": null
							},
							"attachment": {
								"label": "Tilføjede vedhæftninger",
								"error": "Den samlede filstørrelse må ikke overskride 15 MB"
							},
							"add": "Tilføj svar",
							"cancel": "Annuller",
							"submit": {
								"label": "Indsend",
								"error": "Der opstod en fejl, og svaret kunne ikke gemmes. Prøv igen senere."
							}
						}
					}
				},
				"errorView": {
					"429": {
						"title": "Hov!",
						"message": "Noget gik galt. Prøv igen om et øjeblik. Kontakt os for hjælp, hvis problemet fortsætter.",
						"contact": "Når du kontakter vores support, så oplys venligst følgende ID",
						"action": "Kontakt os"
					},
					"error": "Fejl",
					"default": {
						"title": "Hov! Noget gik galt",
						"message": "Af en eller anden grund på vores side kunne vi ikke udføre din anmodning. Du kan prøve igen eller vende tilbage senere.",
						"contact": "Når du kontakter vores support, så oplys venligst følgende ID",
						"action": "Genindlæs"
					}
				}
			},
			"Marketing": {
				"pageTitle": "Grab and Go marketing",
				"banner": {
					"title": "Velkommen til Grab and Go marketing!",
					"subtitle": "Her kan du finde aktiver der er klar til brug til dit websted, e-mail-kampagner og sociale medier marketing.",
					"button": "Få mere at vide"
				},
				"productSection": {
					"title": "Hvilket Klarna produkt tilbyder I handlende?"
				},
				"MarketSelector": {
					"label": "Vælg marked",
					"markets": {
						"BE": "Belgien (hollandsk)",
						"BE-FR": "Belgien (fransk)"
					}
				},
				"ChannelSelector": {
					"pageTitle": {
						"kco": "Klarna Checkout",
						"fourInstallments": "4 afdrag",
						"pin30": "Betal om 30 dage"
					}
				},
				"sourceAndPreview": {
					"helpButton": "Har du brug for hjælp med dette?",
					"copyButton": "Kopiér til udklipsholder",
					"copyButtonSuccess": "Kopieret!",
					"sourceButton": "Kilde",
					"previewButton": "Forhåndsvisning"
				},
				"EmailTemplates": {
					"pageTitle": "E-mail-skabelober",
					"title": "E-mail-skabelober"
				},
				"EmailHeader": {
					"pageTitle": "E-mail marketingbillede",
					"title": "E-mail marketingsbillede"
				},
				"Social": {
					"pageTitle": "Sociale medier",
					"title": "Sociale medier"
				},
				"buttonDownload": "Hent billede",
				"buttonCopy": "Kopier tekst",
				"buttonCopySuccess": "Kopieret!",
				"missingPreview": "Forhåndsvisning mangler",
				"productLinkText": "Hent aktiver",
				"content": {
					"products": {
						"kco": {
							"title": "Klarna Checkout",
							"subtitle": "En komplet udtjekningsløsning med alt samlet på et sted."
						},
						"payNow": {
							"title": "Betal nu",
							"subtitle": "Lad handlende betale for deres indkøb på stedet."
						},
						"threeInstallments": {
							"title": "3 afdrag",
							"subtitle": "Giv de handlende firhed til at fordele udgiften over tid uden renter."
						},
						"fourInstallments": {
							"title": "4 afdrag",
							"subtitle": "Giv de handlende firhed til at fordele udgiften over tid uden renter."
						},
						"pin14": {
							"title": "Betal om 14 dage",
							"subtitle": "Betal om 14 dage. Ingen renter eller ekstra gebyrer."
						},
						"pin21": {
							"title": "Betal om 21 dage",
							"subtitle": "Betal om 21 dage. Ingen renter eller ekstra gebyrer."
						},
						"pin30": {
							"title": "Betal om 30 dage",
							"subtitle": "Betal om 30 dage. Ingen renter eller ekstra gebyrer."
						},
						"financing": {
							"title": "Finansiering",
							"subtitle": "Øg salget ved at tilbyde kunderne op til 36 måneders kredit."
						}
					},
					"campaigns": {
						"holidays-2020": {
							"title": "Ferier 2020",
							"channels": {
								"emailHeader": {
									"title": "E-mail marketingsbillede",
									"subtitle": "Fang abonnenters opmærksomhed i denne højsæson med billeder i studiokvalitet til dine e-mailkampagner.",
									"linkText": "Vis billeder",
									"introduction": "Det er på tide at fortælle dine abonnenter om dine fantastiske tilbud og rabatter i højsæsonen. Hent et billede og tilføj det til din e-mailkampagne eller sidehovedet på din e-mailskabelon for at få den største virkning."
								},
								"social": {
									"title": "Sociale medier",
									"subtitle": "Få flere kunder i butikken i denne højsæson med disse gratis billeder.",
									"linkText": "Vis opslag",
									"introduction": "Det er på tide at dele budskabet om dine fantastiske tilbud og rabatter i højsæsonen. Du skal blot hente aktiverne og overføre dem til dine sociale medieprofiler eller planlægningsværktøjer. Husk at tagge {link} i dine meddelelser for at nå ud til endnu flere handlende og kundeemner."
								}
							},
							"imageAlt": {
								"holiday1": "Person i en blå, lyserød og sølvfarvet kropsdragt glider på ét knæ mod en gulvskrubbe; én arm holdes ud på en sølvfarvet sko, og den anden holder en telefon.",
								"holiday2": "Person i burgundfarvet satinpyjamas svæver i lotusstilling over et par blæsere med en telefon, der svæver i øjenhøjde."
							}
						},
						"at-launch": {
							"title": "Ved lancering",
							"subtitle": "Har du lige begyndt din rejse med os? Brug disse aktiver til at fortælle de handlende, både gamle og nye, at du er live med Klarna.",
							"channels": {
								"email": {
									"title": "E-mail-skabelober",
									"subtitle": "Lad dine abonnenter vide, at der findes en ny måde at betale på ved kassen.",
									"linkText": "Vis skabeloner",
									"introduction": "Det er på tide at lade dine abonnenter vide at du lancerer med Klarna! Du skal blot kopiere og indsætte skabelonen eller indholdet i din e-mail-platform, så er du klar til at gå i gang.",
									"codeBoxTitle": "Start e-mail"
								},
								"social": {
									"title": "Sociale medier",
									"subtitle": "Tiltræk dine handlende til din butik med disse smoooth billeder i studiekvalitet.",
									"linkText": "Vis opslag",
									"introduction": "Det er på tide at lade hele verden vide, at du lancerer med Klarna! Du skal blot hente disse aktiver og uploade dem til dine sociale medieprofiler eller planlægningsværktøjer. Husk at tagge {link} i din bekendtgørelse, for at nå ud til endnu flere handlende og kundeemner."
								},
								"osm": {
									"title": "Landingsside",
									"subtitle": "Vær fleksibel og informer de handlende om, hvordan man handler med Klarna.",
									"linkText": "Vis sider"
								}
							},
							"imageAlt": {
								"emotional": "En person med langt krøllet hår iført en lilla jumpsuit, spiller på flippermaskine",
								"paymentShowcase": "En hånd der holder en telefon viser Klarna-logoet, og rulleskøjter i baggrunden",
								"simplified": "Telefon med displayet nedad på en flippermaskine til højre og en stærk gul sofa til venstre",
								"device": "En telefon der viser Klarna-logoet dinglende fra billedet, lyserødt værelse med lysekrone i baggrunden"
							}
						}
					}
				}
			}
		}
	}
};